import React from 'react';
import { styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { Colors } from 'library';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    onSubmit?: () => void;
    placeholder?: string;
    autoFocus?: boolean;
}

export function SearchInput({ value, onChange, onSubmit, placeholder = 'Search...', autoFocus }: SearchInputProps) {
    return (
        <Wrapper>
            <Icon>
                <Search sx={{ fontSize: 20, color: Colors.mediumGrey }} />
            </Icon>
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') onSubmit?.();
                }}
                autoFocus={autoFocus}
            />
        </Wrapper>
    );
}

const Wrapper = styled('div')({
    position: 'relative',
    flex: 1,
});

const Icon = styled('span')({
    position: 'absolute',
    left: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
});

const Input = styled('input')({
    width: '100%',
    padding: '10px 14px 10px 40px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.lightGrey,
    },
});
